import { styled, TypographyProps } from '@material-ui/core';
import CustomizedTypography from '../CustomizedTypography';

interface Props extends TypographyProps {
  as?: 'span' | 'p';
  fontWeight?: '100' | '300' | '500' | '700' | '900' | 'bold' | 'normal';
  gutterBottoms?: number;
}

const CustomizedModalTitle = ({ as, ...props }: Props) => {
  return (
    <TitleWrapper>
      <CustomizedTypography
        {...props}
        className="title"
        variant="h4"
        fontWeight="bold"
      />
    </TitleWrapper>
  );
};

export default CustomizedModalTitle;

const TitleWrapper = styled('div')({
  position: 'relative',
  padding: '22px 24px',
  '& .title': {
    padding: '6px 0px'
  }
});
